<app-coming-soon title="Running Tasks" icon="rowing"></app-coming-soon>
